module.exports = __webpack_public_path__ + "img/turkcell-t50.6129600d.jpg";